module.exports = __webpack_public_path__ + "static/media/factuur.e0c4c848.jpg";